import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import debounce from 'lodash/debounce';
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { cancelEvent, clearEvent, createAndFireEventInElementsChannel, deleteEvent, failedEvent, focusEvent, searchedEvent, selectEvent, startSession } from '../analytics';
import { batchByKey } from './batch';
import { messages } from './i18n';
import { callCallback, extractOptionValue, getOptions, isIterable, isPopupUserPickerByComponent, isSingleValue, optionToSelectableOptions } from './utils';

var loadingMessage = function loadingMessage() {
  return null;
};

export var BaseUserPickerWithoutAnalytics = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseUserPickerWithoutAnalytics, _React$Component);

  var _super = _createSuper(BaseUserPickerWithoutAnalytics);

  function BaseUserPickerWithoutAnalytics(props) {
    var _this;

    _classCallCheck(this, BaseUserPickerWithoutAnalytics);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getSessionId", function () {
      return _this.session && _this.session.id ? _this.session.id : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "withSelectRef", function (callback) {
      return function () {
        if (_this.selectRef) {
          callback(_this.selectRef.select.select);
        }
      };
    });

    _defineProperty(_assertThisInitialized(_this), "nextOption", _this.withSelectRef(function (select) {
      return select.focusOption('down');
    }));

    _defineProperty(_assertThisInitialized(_this), "previousOption", _this.withSelectRef(function (select) {
      return select.focusOption('up');
    }));

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      if (_this.selectRef && _this.selectRef.focus) {
        _this.selectRef.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      if (_this.selectRef && _this.selectRef.blur) {
        _this.selectRef.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "selectOption", _this.withSelectRef(function (select) {
      var focusedOption = select.state.focusedOption;
      select.selectOption(focusedOption);
    }));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, _ref) {
      var action = _ref.action,
          removedValue = _ref.removedValue,
          option = _ref.option;

      if (removedValue && removedValue.data.fixed) {
        return;
      }

      _this.resetInputState();

      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSelection = _this$props.onSelection,
          onClear = _this$props.onClear,
          isMulti = _this$props.isMulti;
      callCallback(onChange, extractOptionValue(value), action);

      switch (action) {
        case 'select-option':
          if (value && !Array.isArray(value)) {
            callCallback(onSelection, value.data, _this.getSessionId());
          }

          _this.fireEvent(selectEvent, isMulti ? option : value);

          _this.session = isMulti ? startSession() : undefined;
          break;

        case 'clear':
          callCallback(onClear);

          _this.fireEvent(clearEvent);

          break;

        case 'remove-value':
        case 'pop-value':
          if (removedValue) {
            _this.fireEvent(deleteEvent, removedValue.data);
          }

          break;
      }

      _this.fireEvent(searchedEvent);

      if (removedValue && _this.state.value && Array.isArray(_this.state.value)) {
        var remainingValues = _this.state.value.filter(function (val) {
          return val.data.id !== removedValue.data.id;
        });

        _this.setState({
          value: remainingValues ? remainingValues : []
        });
      }

      if (!_this.props.value) {
        _this.setState({
          value: value ? value : []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectRef", function (ref) {
      _this.selectRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "addOptions", batchByKey(function (request, newOptions) {
      var resolving = _this.state.resolving;

      _this.setState(function (_ref2) {
        var inflightRequest = _ref2.inflightRequest,
            options = _ref2.options,
            count = _ref2.count;

        if (inflightRequest.toString() === request) {
          return {
            options: (resolving ? options : []).concat(newOptions.reduce(function (nextOptions, item) {
              return Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item);
            }, [])),
            count: count - newOptions.length,
            resolving: count - newOptions.length !== 0
          };
        }

        return null;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleLoadOptionsError", function () {
      var count = _this.state.count;
      var newCount = count - 1;

      _this.setState({
        count: newCount,
        resolving: newCount !== 0
      });

      _this.fireEvent(failedEvent);
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedLoadOptions", debounce(function (search) {
      var loadOptions = _this.props.loadOptions;

      if (loadOptions) {
        _this.setState(function (_ref3) {
          var previousRequest = _ref3.inflightRequest;
          var inflightRequest = previousRequest + 1;
          var result = _this.session && _this.session.id ? loadOptions(search, _this.session.id) : loadOptions(search);

          var addOptions = _this.addOptions.bind(_assertThisInitialized(_this), inflightRequest.toString());

          var count = 0;

          if (isIterable(result)) {
            var _iterator = _createForOfIteratorHelper(result),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _value = _step.value;
                Promise.resolve(_value).then(addOptions).catch(_this.handleLoadOptionsError);
                count++;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          } else {
            Promise.resolve(result).then(addOptions).catch(_this.handleLoadOptionsError);
            count++;
          }

          return {
            inflightRequest: inflightRequest,
            count: count,
            resolving: count !== 0,
            options: []
          };
        });
      }
    }, 200));

    _defineProperty(_assertThisInitialized(_this), "executeLoadOptions", function (search) {
      var loadOptions = _this.props.loadOptions;

      if (loadOptions) {
        _this.setState({
          resolving: true
        }, function () {
          return _this.debouncedLoadOptions(search);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (event) {
      var _this$state = _this.state,
          value = _this$state.value,
          menuIsOpen = _this$state.menuIsOpen;

      if (!menuIsOpen || !_this.session) {
        _this.startSession();
      }

      callCallback(_this.props.onFocus, _this.getSessionId());

      _this.setState({
        menuIsOpen: true
      });

      if (!_this.props.isMulti && isSingleValue(value)) {
        var input = event.target;

        _this.setState({
          inputValue: value.label
        }, function () {
          if (input instanceof HTMLInputElement) {
            input.select();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resetInputState", function () {
      // Prevent filter if query typed, then blurred with no selection
      _this.setState({
        inputValue: ''
      });

      callCallback(_this.props.onInputChange, '', _this.getSessionId());
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      callCallback(_this.props.onBlur, _this.getSessionId());

      if (isPopupUserPickerByComponent(_this.props.SelectComponent)) {
        return;
      }

      _this.resetInputState();

      _this.setState({
        menuIsOpen: false,
        options: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.resetInputState();

      callCallback(_this.props.onClose, _this.getSessionId());

      _this.setState({
        menuIsOpen: false,
        options: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (search, _ref4) {
      var action = _ref4.action;

      if (action === 'input-change' || action === 'set-value') {
        callCallback(_this.props.onInputChange, search, _this.getSessionId());

        _this.setState({
          inputValue: search
        });

        _this.executeLoadOptions(search);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fireEvent", function (eventCreator) {
      var createAnalyticsEvent = _this.props.createAnalyticsEvent;

      if (createAnalyticsEvent) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        createAndFireEventInElementsChannel(eventCreator.apply(void 0, [_this.props, _this.state, _this.session, _this.journeyId].concat(args)))(createAnalyticsEvent);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "startSession", function () {
      _this.session = startSession();
      _this.journeyId = _this.getSessionId();

      _this.fireEvent(focusEvent);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      // Escape
      if (event.keyCode === 27) {
        _this.blur();
      } // Space


      if (event.keyCode === 32 && !_this.state.inputValue) {
        event.preventDefault();

        _this.setState({
          inputValue: ' '
        });
      }

      if (_this.session) {
        _this.session.lastKey = event.keyCode;

        switch (event.keyCode) {
          // KeyUp 38
          case 38:
            _this.session.upCount++;
            break;
          // KeyDown 40

          case 40:
            _this.session.downCount++;
            break;
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClearIndicatorHover", function (hoveringClearIndicator) {
      _this.setState({
        hoveringClearIndicator: hoveringClearIndicator
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var options = getOptions(_this.state.options) || [];
      var _this$props2 = _this.props,
          maxOptions = _this$props2.maxOptions,
          isMulti = _this$props2.isMulti;

      if (maxOptions === 0) {
        return [];
      }

      if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
        var _value2 = _this.state.value;
        var filteredOptions = options; // Filter out previously selected options

        if (isMulti && Array.isArray(_value2)) {
          var valueIds = _value2.map(function (item) {
            return item.data.id;
          });

          filteredOptions = options.filter(function (option) {
            return valueIds.indexOf(option.data.id) === -1;
          });
        }

        return filteredOptions.slice(0, maxOptions);
      }

      return options;
    });

    _defineProperty(_assertThisInitialized(_this), "getAppearance", function () {
      return _this.props.appearance ? _this.props.appearance : 'normal';
    });

    _this.state = {
      options: [],
      isDefaultSet: false,
      inflightRequest: 0,
      count: 0,
      hoveringClearIndicator: false,
      menuIsOpen: !!_this.props.open,
      inputValue: props.search || '',
      resolving: false
    };
    return _this;
  }

  _createClass(BaseUserPickerWithoutAnalytics, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          open = _this$props3.open,
          search = _this$props3.search; // load options when the picker open

      if (open) {
        if (!this.session) {
          this.startSession();
        }

        this.executeLoadOptions(search);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var _this$state2 = this.state,
          menuIsOpen = _this$state2.menuIsOpen,
          options = _this$state2.options; // load options when the picker open

      if (menuIsOpen && !prevState.menuIsOpen) {
        if (!this.session) {
          // session should have been created onFocus
          this.startSession();
        }

        this.executeLoadOptions();
      }

      if (!menuIsOpen && prevState.menuIsOpen && this.session) {
        this.fireEvent(cancelEvent, prevState);
        this.session = undefined;
      }

      if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) {
        this.fireEvent(searchedEvent);
      }

      if (this.state.inputValue !== prevState.inputValue) {
        if (this.session) {
          this.session.inputChangeTime = Date.now();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          isMulti = _this$props4.isMulti,
          isLoading = _this$props4.isLoading,
          subtle = _this$props4.subtle,
          noBorder = _this$props4.noBorder,
          placeholder = _this$props4.placeholder,
          isClearable = _this$props4.isClearable,
          isDisabled = _this$props4.isDisabled,
          clearValueLabel = _this$props4.clearValueLabel,
          menuMinWidth = _this$props4.menuMinWidth,
          menuPortalTarget = _this$props4.menuPortalTarget,
          addMoreMessage = _this$props4.addMoreMessage,
          noOptionsMessage = _this$props4.noOptionsMessage,
          disableInput = _this$props4.disableInput,
          components = _this$props4.components,
          pickerProps = _this$props4.pickerProps,
          SelectComponent = _this$props4.SelectComponent,
          styles = _this$props4.styles,
          autoFocus = _this$props4.autoFocus,
          fieldId = _this$props4.fieldId,
          inputId = _this$props4.inputId,
          maxPickerHeight = _this$props4.maxPickerHeight,
          textFieldBackgroundColor = _this$props4.textFieldBackgroundColor;
      var _this$state3 = this.state,
          count = _this$state3.count,
          hoveringClearIndicator = _this$state3.hoveringClearIndicator,
          menuIsOpen = _this$state3.menuIsOpen,
          value = _this$state3.value,
          inputValue = _this$state3.inputValue,
          resolving = _this$state3.resolving;
      var appearance = this.getAppearance();
      return /*#__PURE__*/React.createElement(SelectComponent, _extends({
        value: value,
        autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
        ref: this.handleSelectRef,
        isMulti: isMulti,
        options: this.getOptions(),
        styles: styles,
        enableAnimation: isMulti,
        components: components,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        isLoading: count > 0 || resolving || isLoading,
        loadingMessage: loadingMessage,
        menuPlacement: "auto",
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : /*#__PURE__*/React.createElement(FormattedMessage, messages.placeholder),
        addMoreMessage: addMoreMessage,
        classNamePrefix: "fabric-user-picker",
        hoveringClearIndicator: hoveringClearIndicator,
        appearance: appearance,
        isClearable: isClearable,
        noBorder: noBorder,
        subtle: subtle,
        blurInputOnSelect: !isMulti,
        closeMenuOnSelect: !isMulti,
        noOptionsMessage: noOptionsMessage,
        openMenuOnFocus: true,
        isDisabled: isDisabled,
        isFocused: menuIsOpen,
        backspaceRemovesValue: isMulti,
        filterOption: null // disable local filtering
        ,
        clearValueLabel: clearValueLabel,
        menuMinWidth: menuMinWidth,
        menuPortalTarget: menuPortalTarget,
        disableInput: disableInput || isDisabled,
        instanceId: fieldId,
        inputId: inputId,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClose: this.handleClose,
        onInputChange: this.handleInputChange,
        onClearIndicatorHover: this.handleClearIndicatorHover,
        onKeyDown: this.handleKeyDown,
        maxPickerHeight: maxPickerHeight,
        textFieldBackgroundColor: textFieldBackgroundColor
      }, pickerProps));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var derivedState = {};

      if (nextProps.open !== undefined) {
        derivedState.menuIsOpen = nextProps.open;
      }

      if (nextProps.value !== undefined) {
        derivedState.value = optionToSelectableOptions(nextProps.value);
      } else if (nextProps.defaultValue && Array.isArray(nextProps.defaultValue) && nextProps.defaultValue.length > 0 && !prevState.isDefaultSet) {
        derivedState.value = optionToSelectableOptions(nextProps.defaultValue);
        derivedState.isDefaultSet = true;
      }

      if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) {
        derivedState.inputValue = nextProps.search;
      }

      if (nextProps.options !== undefined) {
        derivedState.options = nextProps.options;
      }

      return derivedState;
    }
  }]);

  return BaseUserPickerWithoutAnalytics;
}(React.Component);

_defineProperty(BaseUserPickerWithoutAnalytics, "defaultProps", {
  isMulti: false,
  subtle: false,
  noBorder: false,
  textFieldBackgroundColor: false,
  isClearable: true
});

export var BaseUserPicker = withAnalyticsEvents()(BaseUserPickerWithoutAnalytics);